/** Where to send someone who hasn't picked a service yet. */
export const ALL_SERVICES_HREF = '/pl#services'

// `serviceHref` and its `SERVICE_PAGES` map lived here to power the cart's
// "back to the offer" chip. That chip retired with the cart: on a merged screen
// it pointed away from the very surface being configured. The map was also
// provably wrong — keyed on legacy service ids like `studio nagrań` while what
// actually reached it were offering slugs like `studio-nagran`, so the lookup
// missed and every visitor got the overview fallback regardless.
